module.exports = __webpack_public_path__ + "static/media/inner-join-icon.67a1aaf1.svg";